import type {
	AuthRefreshRequest,
	AuthStartRequest,
} from "../redux/types/auth.types";

import ishipDocsClient from "./clients/ishipdocs.client";
import apiEndPOints from "./api.endpoints";
import {
	MarkOrderCompletePayload,
	QuoteOrderPayload,
	UpdateOrderPayload,
} from "../redux/types/order.types";
import { errorlogpayload } from "../redux/types/upload.types";

export const sendOTP = (payload: AuthStartRequest, recaptchaToken?: string) => {
	return ishipDocsClient.post(
		apiEndPOints.LOGIN_START,
		{ ...payload },
		{
			headers: {
				"g-recaptcha-response": recaptchaToken,
			},
		}
	);
};

export const verifyOtp = (payload: AuthStartRequest) => {
	return ishipDocsClient.post(apiEndPOints.LOGIN_VERIFY_OTP, { ...payload });
};

export const refreshToken = (payload: AuthRefreshRequest) => {
	return ishipDocsClient.post(apiEndPOints.LOGIN_REFRESH_TOKEN, { ...payload });
};

export const getLocationDetails = (params: { slug: string }) => {
	return ishipDocsClient.get(
		`${apiEndPOints.GET_LOCATION_DETAILS}/${params.slug}`
	);
};

export const getLocationDetailsKey = (params: { dropboxName: string }) => {
	return ishipDocsClient.get(apiEndPOints.GET_LOCATION_DETAILS_KEY, { params });
};

export const getS3BucketDetails = () => {
	return ishipDocsClient.get(apiEndPOints.GET_S3_BUCKET_DETAILS);
};

export const createOrderQuote = (body: QuoteOrderPayload) => {
	return ishipDocsClient.post(apiEndPOints.QUOTE_ORDER, body);
};

export const updateOrderAsDone = (body: MarkOrderCompletePayload) => {
	return ishipDocsClient.post(apiEndPOints.COMPLETE_ORDER, body);
};

export const updateOrderItems = (body: UpdateOrderPayload) => {
	return ishipDocsClient.post(apiEndPOints.UPDATE_ORDER_ITEMS, body);
};

export const errorlogItems = (body: errorlogpayload) => {
	return ishipDocsClient.post(apiEndPOints.ERROR_LOG_ENDPOINT, body);
};

export const getinfofromzip = (body: { zip: string }) => {
	return ishipDocsClient.get(apiEndPOints.GET_INFORMATION_ZIP, {
		params: body,
	});
};
